axboot.tabBuilder = function () {
    var defaultTabConfig = {

    };

    return function (_config) {
        var myTabConfig = $.extend(true, {}, defaultTabConfig, _config);

        myTabConfig.onOpenTab = function () {
            var activeTabPanel = this.activePanel.$target.get(0);

            this.activePanel.$target.find('[data-fit-height-content]').each(function () {
                var $this = $(this);
                var _pHeight = $this.offsetParent().height();
                var name = this.getAttribute("data-fit-height-content");
                var _asideHeight = 0;
                $('[data-fit-height-aside="' + name + '"]').each(function () {
                    _asideHeight += $(this).outerHeight();
                });
                $this.css({ height: _pHeight - _asideHeight });
            });

            myTabConfig.target.ax5layout('reset');

            if (ax5.ui.grid_instance) {
                for (var gi = 0, gl = ax5.ui.grid_instance.length; gi < gl; gi++) {
                    var target = ax5.util.findParentNode(ax5.ui.grid_instance[gi].$target.get(0), function (_el) {
                        return activeTabPanel == _el;
                    });
                    if (target) {
                        ax5.ui.grid_instance[gi].setHeight(ax5.ui.grid_instance[gi].$target.height());
                        ax5.ui.grid_instance[gi].repaint();
                    }
                }
            }

            if (!ax5.util.isNothing(myTabConfig.onChangeTab) && ax5.util.isFunction(myTabConfig.onChangeTab)) {
                var selectedTab = axboot.util.getActiveTab(myTabConfig.target.ax5layout('getActiveTab'));

                myTabConfig.onChangeTab(selectedTab);

                // change 이벤트 발생 후 초기화가 완료된 것으로 간주.
                selectedTab.$target.data('initTab', true);
            }
        }

        return myTabConfig.target.ax5layout(myTabConfig);
    }
}();